<div class="w-full max-w-md mx-auto bg-white dark:bg-gray-900 p-4">
  <div class="flex justify-between items-center mb-4">
    <button (click)="previousMonth()" class="text-gray-600 dark:text-white hover:text-blue-500">
      <app-chevron-left></app-chevron-left>
    </button>
    <h2 class="text-lg font-semibold text-gray-800 dark:text-white">
      {{ format(currentMonth(), 'MMMM yyyy', { locale: locale }) }}
    </h2>
    <button (click)="nextMonth()" class="text-gray-600 dark:text-white hover:text-blue-500">
      <app-chevron-right></app-chevron-right>
    </button>
  </div>


  <div class="grid grid-cols-7 gap-1 text-center text-sm text-gray-600 dark:text-white font-medium mb-2">
    <div *ngFor="let day of ['D', 'L', 'M', 'M', 'J', 'V', 'S']">{{ day }}</div>
  </div>

  <div class="grid grid-cols-7 gap-1 text-center text-sm">
    <ng-container *ngFor="let week of weeks()">
      <ng-container *ngFor="let day of week">
        <button (click)="selectDate(day)" [class.bg-brand-600]="isSameDay(day, selectedDate()!)"
          [class.text-white]="isSameDay(day, selectedDate()!)"
          [ngClass]="!isSameMonth(day, currentMonth()) ? 'text-gray-300 dark:text-gray-400': ''"
          class="w-9 h-9 rounded-full hover:bg-blue-100 dark:hover:bg-blue-800 dark:text-white/60 transition-all">
          {{ format(day, 'd') }}
        </button>
      </ng-container>
    </ng-container>
  </div>
</div>